"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryEditorModeToggle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
const types_1 = require("../types");
const editorModes = [
    { label: 'Builder', value: types_1.QueryEditorMode.Builder },
    { label: 'Code', value: types_1.QueryEditorMode.Code },
];
function QueryEditorModeToggle({ mode, onChange }) {
    return (react_1.default.createElement("div", { "data-testid": 'QueryEditorModeToggle' },
        react_1.default.createElement(ui_1.RadioButtonGroup, { options: editorModes, size: "sm", value: mode, onChange: onChange })));
}
exports.QueryEditorModeToggle = QueryEditorModeToggle;
//# sourceMappingURL=QueryEditorModeToggle.js.map